module.exports = __webpack_public_path__ + "static/media/Adaa.f032752d.png";